<div class="d-flex content-height">
  <div class="align-self-center full-width"><ng-content></ng-content></div>
</div>
